// extracted by mini-css-extract-plugin
export default {"footer":"CartFooter-module__footer___l7vkL colors-module__text-dark___InHyq"};